import { atom } from "recoil";

export const orderSuccessfulProvider = atom({
  key: "orderSuccessfulProvider",
  default: false,
});
